import { render, staticRenderFns } from "./DiagManagementDetailSaveTutorial.vue?vue&type=template&id=d2eaad98&"
import script from "./DiagManagementDetailSaveTutorial.vue?vue&type=script&lang=js&"
export * from "./DiagManagementDetailSaveTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports